<div
  class="min-h-screen bg-surface-50 dark:bg-teal-950"
  [attr.data-theme]="layoutService.isDarkTheme() ? 'dark' : 'light'">
  <section class="min-h-screen flex flex-col items-center justify-center">
    <div app-card elevated class="flex flex-row items-center justify-center bg-white dark:bg-teal-900 w-[800px] h-96">
      <div
        class="flex flex-col items-center gap-4 mb-10 text-center w-1/3 p-10 border-r border-teal-950 dark:border-teal-200">
        <div
          class="rf-root-in-logo flex items-center justify-center rounded-3xl bg-surface-0 dark:bg-teal-900 p-7 ring-1 ring-teal-900/[0.08] dark:ring-green-500/20">
          <app-convivia-logo size="4.25rem" />
        </div>
        <h1
          class="rf-root-in-title font-montserrat font-semibold text-2xl leading-tight text-teal-950 dark:text-green-500">
          Convivia
        </h1>
      </div>
      <div class="rf-root-in-card w-2/3 p-10 dark:text-white">
        <div class="flex flex-col items-center justify-center text-center">
          <div class="flex items-center justify-center mb-3">
            <app-warning-icon width="126" height="114" />
          </div>
          <h3 class="font-semibold text-2xl mt-4">No tienes permisos para acceder a esta página</h3>
          <p class="general-fallback-secondary-message"
            >Por favor, contacta a tu administrador para obtener acceso a esta página.</p
          >
          <div class="flex gap-2 mt-4">
            <a pButton type="button" href="/app" aria-label="Ir al inicio de la aplicación">Ir al inicio</a>
            <button pButton type="button" class="p-button-text" (click)="closeSession()">Cerrar sesión</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
